import { Navigate, Outlet} from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const ProtectedRoute = ({ children }) => {
  const { user, loggedIn } = useAuth();
  if (!loggedIn()) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};